import { IUnit } from '../types/unit';

export const soldStatuses = ['F', 'C', 'O', 'S'];

export const dateFormatOptions = [
  { label: '04/29/1453', value: 'P' },
  { label: 'Apr 29, 1453', value: 'PP' },
  { label: 'April 29th, 1453', value: 'PPP' },
  { label: '1453', value: 'yyyy' },
  { label: '53', value: 'yy' },
  { label: 'December', value: 'MMMM' },
  { label: '31st', value: 'do' },
  { label: '31', value: 'dd' },
  { label: '1453/04/29', value: 'yyyy/MM/dd' },
];

export const unitStatusTitles = [
  {
    name: 'Available',
    code: 'A',
    color: '#ffffff',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Designated',
    code: 'D',
    color: '#9b5f5f',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Corporate Hold',
    code: 'CH',
    color: '#CCC0DA',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Marketing Hold',
    code: 'M',
    color: '#D9D9D9',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Unit Transfer',
    code: 'UT',
    color: '#5077d0',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Worksheet',
    code: 'W',
    color: '#fb00ff',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Worksheet Approved',
    code: 'WA',
    color: '#fd73ff',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Prepping',
    code: 'P',
    color: '#ffaeae',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'In Person Signing',
    code: 'IP',
    color: '#6e7ff9',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Out for Signing',
    code: 'O',
    color: '#E6B8B7',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Signed',
    code: 'S',
    color: '#ac71dd',
    type: 'preconstruction',
    category: 'inventory',
  },
  {
    name: 'Conditional',
    code: 'C',
    color: '#92D050',
    type: 'preconstruction',
    category: 'sales',
  },
  {
    name: 'Firm',
    code: 'F',
    color: '#00B0F0',
    type: 'preconstruction',
    category: 'sales',
  },
  {
    name: 'Available',
    code: 'A',
    color: '#ffffff',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Hold',
    code: 'H',
    color: '#f99e3b',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Ready To List',
    code: 'RL',
    color: '#b96ef6',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Listing Out For Signing',
    code: 'LOFS',
    color: '#fdfa73',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Listed',
    code: 'LIST',
    color: '#f21c1c',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Tenancy Out For Signing',
    code: 'TOFS',
    color: '#fca1c6',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Leased Conditional',
    code: 'LC',
    color: '#92D050',
    type: 'leasing',
    category: 'inventory',
  },
  {
    name: 'Leased',
    code: 'L',
    color: '#00B0F0',
    type: 'leasing',
    category: 'sales',
  },
  {
    name: 'Terminated',
    code: 'TERM',
    color: '#a400f0',
    type: 'leasing',
    category: 'inventory',
  },
];

export const unitTypes = [
  'Studio',
  'JR1BR',
  '1BR',
  '1BR(I)',
  '1BR+M',
  '1BR+F',
  '1BR+D',
  '1BR+S',
  '1BR+D(I)',
  '1BR+M(I)',
  '2BR',
  '2BR(I)',
  '2BR+M',
  '2BR+F',
  'JR2',
  '2BR+D',
  '2BR+S',
  '2BR+D(I)',
  '2BR+M(I)',
  '3BR',
  '3BR(I)',
  '3BR+M',
  '3BR+F',
  '3BR+D',
  '4BR',
  'TH',
  'C',
];

export const adjustmentTypes = ['Charge', 'Credit', 'ChargePerDeposit', 'Other'];

export const adjustmentNameTypes = ['FreeMaintenance', 'RentalGuarantee', 'CreditDeductedFromNetUnitPrice'];

export const constructionTypes = ['Floor Plan Change', 'Decor Request'];

export const listingBrokerageCommission = [
  `One Month's Rent`,
  `One Month's Rent + HST`,
  `Half Month's Rent`,
  `Half Month's Rent + HST`,
  `Add One Month + HST plus see Rental Management agreement attached Herewith`,
  "75% of One Month's Rent or 25% if no coop broker",
];

export const parkingSpaces = ['Drive', 'Garage'];

export const parkingTypes = ['Common', 'Compact', 'Exclusive', 'None', 'Owned', 'Rental', 'Stacked'];

export const washroomTypes = ['Second', 'Third', 'Basement', 'Flat', 'Ground', 'In Between', 'Lower', 'Main', 'Sub-Basement', 'Upper'];

export const changeTypes = ['Unit Types', 'Model Types', 'Decor', 'Surveyor', 'Floor Plan', 'Price', 'APS'];

export const interiorFeatures = [
  'Accessory Apartment',
  'Air Exchanger',
  'Atrium',
  'Auto Garage Door Remote',
  'Bar Fridge',
  'Brick & Dream',
  'Built-In Oven',
  'Carpet Free',
  'Central Vacuum',
  'Countertop Range',
  'ERV/HRV',
  'Floor Drain',
  'Garburator',
  'Generator - Full',
  'Generator - Partial',
  'Guest Accomodations',
  'In-Law Capability',
  'In-Law Suite',
  'Intercom',
  'None',
  'On Demand Water Heater',
  'Other',
  'Primary Bedroom - Main Floor',
  'Propane Tank',
  'Rough-In Bath',
  'Sauna',
  'Separate Heating Controls',
  'Separate Hydro Meter',
  'Sewage Pump',
  'Solar Owned',
  'Solar Tube',
  'Steam Room',
  'Storage',
  'Storage Area Lockers',
  'Sump Pump',
  'Suspended Ceilings',
  'Trash Compactor',
  'Upgraded Insulation',
  'Ventialation System',
  'Water Heater',
  'Water Heater Owned',
  'Water Meter',
  'Water Purifier',
  'Water Softener',
  'Water Treatment',
  'Wheelchair Access',
  'Workbench',
];

export const menus = [
  {
    title: 'Information',
    icon: 'InfoIcon',
    link: 'dashboard/information',
    subMenu: false,
    permission: '',
    color: '#f7a13d',
  },
  {
    title: 'Price Grid',
    icon: 'GridOnIcon',
    link: 'dashboard/price-grid',
    subMenu: false,
    permission: 'priceGrid',
    color: '#33d10a',
  },
  {
    title: 'Worksheets',
    icon: 'WorksheetIcon',
    link: 'dashboard/worksheets',
    subMenu: false,
    permission: '',
    color: '#f44848',
  },
  {
    title: 'Reports',
    icon: 'InsertChartIcon',
    link: 'dashboard/reports',
    subMenu: true,
    color: '#00b0f0',
    subMenuList: [
      {
        title: 'Closing Report',
        link: 'closing-report',
        icon: 'SummarizeIcon',
      },
      {
        title: 'Unit Report',
        link: 'unit-report',
        icon: 'AssessmentIcon',
      },
      {
        title: 'Daily Summary Report',
        link: 'daily-report',
        icon: 'AnalyticsIcon',
      },
      {
        title: 'Mortgage Report',
        link: 'mortgage-report',
        icon: 'AccountBalanceIcon',
      },
      {
        title: 'Options Report',
        link: 'option-report',
        icon: 'LocalParkingIcon',
      },
      {
        title: 'Deposits Report',
        link: 'deposit-report',
        icon: 'AssignmentIcon',
      },
      {
        title: 'Realtors Report',
        link: 'realtors-report',
        icon: 'QueryStatsIcon',
      },
      {
        title: 'Purchasers Report',
        link: 'purchasers-report',
        icon: 'InsightsIcon',
      },
      {
        title: 'Worksheets Report',
        link: 'worksheet-report',
        icon: 'LeaderboardIcon',
      },
      {
        title: 'Construction Report',
        link: 'construction-report',
        icon: 'ConstructionIcon',
      },
      {
        title: 'Decor Report',
        link: 'decor-report',
        icon: 'HouseIcon',
      },
      {
        title: 'Combined Report',
        link: 'combined-report',
        icon: 'TableIcon',
      },
    ],
    permission: 'viewReports',
  },
  {
    title: 'Outstandings',
    icon: 'ReceiptIcon',
    link: 'dashboard/outstandings',
    subMenu: false,
    permission: 'viewOutstandings',
    color: '#f6ce26',
  },
  {
    title: 'Distribution',
    icon: 'DistributionIcon',
    link: 'dashboard/distribution',
    subMenu: false,
    permission: '',
    color: '#ac71dd',
  },
  {
    title: 'Activity',
    icon: 'CommentIcon',
    link: 'dashboard/activity',
    subMenu: false,
    permission: 'viewActivities',
    color: '#6e7ff9',
  },
  {
    title: 'In Person Signing',
    icon: 'TabletIcon',
    link: 'signing-portal',
    subMenu: false,
    permission: '',
    color: '#000',
  },
  {
    title: 'Create/Edit Merges',
    icon: 'InsertChartIcon',
    link: 'dashboard/create-merges',
    subMenu: false,
    permission: 'merges',
    color: '#fd73ff',
  },
  {
    title: 'Project Settings',
    icon: 'SettingsIcon',
    link: 'dashboard/project-settings',
    subMenu: false,
    permission: 'projectSettings',
  },
  {
    title: 'Resources',
    icon: 'BackupIcon',
    link: 'dashboard/resources',
    subMenu: false,
    permission: '',
    color: '#06384a',
  },
  {
    title: 'Create Realtor',
    icon: 'PeopleIcon',
    link: 'dashboard/add-realtor',
    subMenu: false,
    permission: '',
    color: '#9b5f5f',
  },
  {
    title: 'Create Purchaser',
    icon: 'PeopleIcon',
    link: 'dashboard/add-purchaser',
    subMenu: false,
    permission: '',
    color: '#9b5f5f',
  },
  {
    title: 'Faqs',
    icon: 'Faqs',
    link: 'dashboard/faqs',
    subMenu: false,
    permission: '',
    color: '#fb00ff',
  },
];

export const signItems = [
  {
    category: 'Sign Fields 1',
    name: 'P1Sign',
    index: 0,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1CorpSign',
    index: 0,
    type: 'corpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1NonCorpSign',
    index: 0,
    type: 'nonCorpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1CorpI',
    index: 0,
    type: 'corpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1NonCorpI',
    index: 0,
    type: 'nonCorpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1CorpDate',
    index: 0,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1NonCorpDate',
    index: 0,
    type: 'nonCorpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1I',
    index: 0,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1Date',
    index: 0,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1Checkbox',
    index: 0,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 1',
    name: 'P1Name',
    index: 0,
    type: 'name',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2Sign',
    index: 1,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2CorpSign',
    index: 1,
    type: 'corpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2NonCorpSign',
    index: 1,
    type: 'nonCorpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2CorpI',
    index: 1,
    type: 'corpInitial',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2NonCorpI',
    index: 1,
    type: 'nonCorpInitial',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2CorpDate',
    index: 1,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2NonCorpDate',
    index: 1,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2I',
    index: 1,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2Date',
    index: 1,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2Checkbox',
    index: 1,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 1',
    name: 'P2Name',
    index: 1,
    type: 'name',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3Sign',
    index: 2,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3CorpSign',
    index: 2,
    type: 'corpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3NonCorpSign',
    index: 2,
    type: 'nonCorpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3I',
    index: 2,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3Date',
    index: 2,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3Checkbox',
    index: 2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 1',
    name: 'P3Name',
    index: 2,
    type: 'name',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4Sign',
    index: 3,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4I',
    index: 3,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4CorpSign',
    index: 3,
    type: 'corpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4NonCorpSign',
    index: 3,
    type: 'nonCorpSignature',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4Date',
    index: 3,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4Checkbox',
    index: 3,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 1',
    name: 'P4Name',
    index: 3,
    type: 'name',
  },
  {
    category: 'Sign Fields 1',
    name: 'ExSign',
    index: -1,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'ExI',
    index: -1,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'ExDate',
    index: -1,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'ExCheckbox',
    index: -1,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 1',
    name: 'ExName',
    index: -1,
    type: 'name',
  },
  {
    category: 'Sign Fields 1',
    name: 'RealSign',
    index: -2,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'RealI',
    index: -2,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'RealDate',
    index: -2,
    type: 'date',
  },
  {
    category: 'Sign Fields 1',
    name: 'RealCheckbox',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 1',
    name: 'RealName',
    index: -2,
    type: 'name',
  },
  {
    category: 'Sign Fields 1',
    name: 'SO1Sign',
    index: -3,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'SO2Sign',
    index: -4,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'SO1I',
    index: -3,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'SO2I',
    index: -4,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'SO3Sign',
    index: -5,
    type: 'signature',
  },
  {
    category: 'Sign Fields 1',
    name: 'SO3I',
    index: -5,
    type: 'initial',
  },
  {
    category: 'Sign Fields 1',
    name: 'WitnessSign',
    index: -6,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessI',
    index: -6,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessDate',
    index: -6,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessName',
    index: -6,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessSign2',
    index: -7,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessI2',
    index: -7,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessDate2',
    index: -7,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessName2',
    index: -7,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessSign3',
    index: -8,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessI3',
    index: -8,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessDate3',
    index: -8,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessName3',
    index: -8,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessSign4',
    index: -9,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessI4',
    index: -9,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessDate4',
    index: -9,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'WitnessName4',
    index: -9,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderName',
    index: -10,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderSign',
    index: -10,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderI',
    index: -10,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderDate',
    index: -10,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderName2',
    index: -11,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderSign2',
    index: -11,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderI2',
    index: -11,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'AccountHolderDate2',
    index: -11,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy1Name',
    index: -12,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy1Sign',
    index: -12,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy1I',
    index: -12,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy1Date',
    index: -12,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy2Name',
    index: -13,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy2Sign',
    index: -13,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy2I',
    index: -13,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy2Date',
    index: -13,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy3Name',
    index: -14,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy3Sign',
    index: -14,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy3I',
    index: -14,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy3Date',
    index: -14,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy4Name',
    index: -15,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy4Sign',
    index: -15,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy4I',
    index: -15,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Tenancy4Date',
    index: -15,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor1Name',
    index: -20,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor1Sign',
    index: -20,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor1I',
    index: -20,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor1Date',
    index: -20,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor2Name',
    index: -21,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor2Sign',
    index: -21,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor2I',
    index: -21,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor2Date',
    index: -21,
    type: 'date',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor3Name',
    index: -22,
    type: 'name',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor3Sign',
    index: -22,
    type: 'signature',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor3I',
    index: -22,
    type: 'initial',
  },
  {
    category: 'Sign Fields 2',
    name: 'Assignor3Date',
    index: -22,
    type: 'date',
  },
  {
    category: 'Sign Fields 3',
    name: 'Assignor4Name',
    index: -23,
    type: 'name',
  },
  {
    category: 'Sign Fields 3',
    name: 'Assignor4Sign',
    index: -23,
    type: 'signature',
  },
  {
    category: 'Sign Fields 3',
    name: 'Assignor4I',
    index: -23,
    type: 'initial',
  },
  {
    category: 'Sign Fields 3',
    name: 'Assignor4Date',
    index: -23,
    type: 'date',
  },
  {
    category: 'Sign Fields 3',
    name: 'SalesRepSign',
    index: -99,
    type: 'signature',
  },
  {
    category: 'Sign Fields 3',
    name: 'SalesRepI',
    index: -99,
    type: 'initial',
  },
  {
    category: 'Sign Fields 3',
    name: 'SalesRepDate',
    index: -99,
    type: 'date',
  },
  {
    category: 'Sign Fields 3',
    name: 'SalesRepCheckbox',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'SalesRepName',
    index: -99,
    type: 'name',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementP1Sign',
    index: 0,
    type: 'acknowledgementSignature',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementP1Date',
    index: 0,
    type: 'acknowledgementDate',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementP2Sign',
    index: 1,
    type: 'acknowledgementSignature',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementP2Date',
    index: 0,
    type: 'acknowledgementDate',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementExSign',
    index: -1,
    type: 'acknowledgementSignature',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementCorpP1Sign',
    index: 0,
    type: 'acknowledgementCorpSignature',
  },
  {
    category: 'Sign Fields 3',
    name: 'AcknowledgementCorpP2Sign',
    index: 1,
    type: 'acknowledgementCorpSignature',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox1',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox2',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox3',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox4',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox5',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox6',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox7',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox8',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox9',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox10',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox11',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox12',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox13',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox14',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox15',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox16',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'RealCheckbox17',
    index: -2,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 3',
    name: 'SalesRepCheckbox1',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox2',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox3',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox4',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox5',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox6',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox7',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox8',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox9',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox10',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox11',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox12',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox13',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox14',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox15',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox16',
    index: -99,
    type: 'CheckBox',
  },
  {
    category: 'Sign Fields 4',
    name: 'SalesRepCheckbox17',
    index: -99,
    type: 'CheckBox',
  },
];

export const mergeItems = [
  {
    category: 'General',
    name: 'Suite',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Unit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'ModelType',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'ModelName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Tier',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'TownhomeSuite',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'UnitAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'UnitCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'UnitProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'UnitPostalCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1P2PfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1P2PfullNameLCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1P3PfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2P3PfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '3P4PfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1P2P3PfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'AllPfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'AllPfullNameLCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1PFN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1PLN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1PLNCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1PfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1PfullNameLCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '&',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'FullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Address',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'City',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Province',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'PCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Country',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Email',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'SIN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Dob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General',
    name: 'SignDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General',
    name: 'ExecuteDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General',
    name: 'Phone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Occupation',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'Company',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'IDType',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'IDJurisdiction',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'IDNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'IDExpiry',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General',
    name: '2PFN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PLN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PLNCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PfullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PfullNameLCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PDob',
    fontSize: 9,
    index: 1,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General',
    name: '2PSIN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PCompany',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2POccupation',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '1PEmployer',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PEmployer',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'WorksheetChoice1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'WorksheetChoice2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: 'WorksheetChoice3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PPhone',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PFullAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General',
    name: '2PCity',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PProvince',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PPCode',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PCountry',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PEmail',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PIDNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpFN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpLN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpLNCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PfullNameNonCorpLCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpDob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 2',
    name: '1PNonCorpSIN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpPhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpFullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpPCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpCountry',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpEmail',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },

  {
    category: 'General 2',
    name: '1PNonCorpFN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpLN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpLNCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpfullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PfullNameNonCorpLCaps',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpDob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 2',
    name: '1PNonCorpSIN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpPhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpFullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpPCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpCountry',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '1PNonCorpEmail',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpFN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpLN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpLNCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpfullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PfullNameNonCorpLCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpDob',
    fontSize: 9,
    index: 1,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 2',
    name: '2PNonCorpSIN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpPhone',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpFullAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpCity',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpProvince',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpPCode',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpCountry',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 2',
    name: '2PNonCorpEmail',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PFN',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PLN',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PLNCaps',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PfullName',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PfullNameLCaps',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PDob',
    fontSize: 9,
    index: 2,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 3',
    name: '3PSIN',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PPhone',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PFullAddress',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PAddress',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PCity',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PProvince',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PPCode',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PCountry',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PEmail',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '3PIDNumber',
    fontSize: 9,
    index: 2,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PFN',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PLN',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PLNCaps',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PfullName',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PfullNameLCaps',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PDob',
    fontSize: 9,
    index: 3,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 3',
    name: '4PSIN',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PPhone',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PFullAddress',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PAddress',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PCity',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PProvince',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PPCode',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PCountry',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PEmail',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: '4PIDNumber',
    fontSize: 9,
    index: 3,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'SalesRep',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'ProjectAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'ProjectAddressSuite',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'ProjectStreetAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'ProjectCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'ProjectProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'ProjectPCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'Directors',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'SO1fullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 3',
    name: 'SO1FullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO1Dob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 4',
    name: 'SO1Email',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO1SIN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO1Phone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO2fullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO2FullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO2Dob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 4',
    name: 'SO2Email',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO2SIN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO2Phone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO3FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO4FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'SO1SO2fullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'MinMortgage',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'netMinMortgage',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalP1CorpOrPurchaserFullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalP2CorpOrPurchaserFullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalCorpName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalCorpDob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'General 4',
    name: 'ConditionalCorpPhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalCorpAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalCorpEmail',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'General 4',
    name: 'ConditionalCorpNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealFN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealLN',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealFullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealEmail',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealFullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealPostCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'RealPhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'BrokeragePhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Brokerage',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'BrokerageFax',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent1W',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Commission1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent2W',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Commission2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent3W',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Commission3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent4W',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Commission4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent5W',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Commission5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'CommissionPercent6W',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Realtor',
    name: 'Commission6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount1NetHstNoRebate',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionPercentAmount6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionFixed1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionFixed2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionFixed3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionFixed4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionFixed5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'CommissionFixed6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit1W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit1Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits',
    name: 'Deposit1DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits',
    name: 'Deposit1%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit1Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit1DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit2W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit2Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits',
    name: 'Deposit2DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits',
    name: 'Deposit2%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit2Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit2DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit3W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit3Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits',
    name: 'Deposit3DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits',
    name: 'Deposit3%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit3Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit3DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit4W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit4Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits',
    name: 'Deposit4DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits',
    name: 'Deposit4%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit4Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit4DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit5W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit5Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits',
    name: 'Deposit5DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits',
    name: 'Deposit5%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit5Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit5DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit6W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits',
    name: 'Deposit6Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit6DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit6%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit6Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit6DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7Decimal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit7DaysDue',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit8W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit8',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit8Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit8DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit8%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit9W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit9',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit9Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit9DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit9%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit10W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit10',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit10Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit10DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit10%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit11W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit11',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit11Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit11%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit12W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit12',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit12Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit12%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit13W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit13',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit13Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit13%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit14W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit14',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit14Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit14%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit15W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit15',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit15Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit15%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit16W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit16',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit16Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit16%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit17W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit17',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 2',
    name: 'Deposit17Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit17%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit18W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit18',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit18Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit18%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit19W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit19',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit19Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit19%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit20W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit20',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit20Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit20%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit21W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit21',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit21Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit21%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit22W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit22',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit22Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit22%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit23W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit23',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit23Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit23%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit24W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit24',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit24Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit24%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit25W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit25',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit25Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit25%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit26W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit26',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit26Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit26%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit27W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit27',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit27Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit27%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit28W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit28',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit28Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit28%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit29W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit29',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit29Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit29%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit30W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit30',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit30Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit30%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 3',
    name: 'Deposit31W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit31',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit31Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit31%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit32W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit32',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit32Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit32%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit33W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit33',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit33Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit33%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit34W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit34',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit34Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit34%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit35W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit35',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit35Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit35%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit36W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit36',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit36Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit36%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit37W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit37',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit37Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit37%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit38W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit38',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit38Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit38%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit39W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit39',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit39Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit39%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit40W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit40',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit40Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit40%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit41W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit41',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit41Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit41%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit42W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit42',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit42Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: 'Deposit42%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: '4thLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: '4thLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: '4thLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposits 4',
    name: '4thLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: '3rdLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposits 4',
    name: '3rdLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: '3rdLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Miscellaneous',
    name: '3rdLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: '2ndLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: '2ndLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: '2ndLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Miscellaneous',
    name: '2ndLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'LastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'LastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'LastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Miscellaneous',
    name: 'LastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'NewDepositBasePrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'NewDepositTotalPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'UPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'UPriceW',
    fontSize: 6,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'NetUPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'TPriceW',
    fontSize: 6,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'NetTPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'NetTPriceW',
    fontSize: 6,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'GrossNetTPriceDifference',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'EffectiveTPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'EffectiveTPriceW',
    fontSize: 6,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'HSTRebateAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'NetHstNoRebateTPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'NetHstNoRebateUPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP1Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP1Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP2Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP2Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP3Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP3Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP4Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP4Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP5Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP5Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP6Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP6Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP7',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP7Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP7Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP8',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP8Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous',
    name: 'OP8Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous',
    name: 'OP9',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'OP9Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'OP9Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous 2',
    name: 'OP10',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'OP10Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'OP10Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous 2',
    name: 'TotalOptionsAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'totalParkingPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous 2',
    name: 'totalParkingNum',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'totalParkingAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'totalLockerPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Miscellaneous 2',
    name: 'totalLockerNum',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'totalLockerAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Rental',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Checkmark',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Schedule A',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'H',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'J',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'K',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'P1Check',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'P2Check',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'P3Check',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'P4Check',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Purchaser1Check',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Corp1Check',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'ResidentialCheck',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'CommercialCheck',
    fontSize: 11,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyPhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyDob',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyOccupation',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyCorp',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: '3rdPartyRelationship',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment1%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment1%Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment1$',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment1$Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment1$WordsAndNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment2%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment2%Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment2$',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment2$Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment2$WordsAndNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment3%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment3%Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 2',
    name: 'Adjustment3$',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment3$Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment3$WordsAndNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment4%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment4%Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment4$',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment4$Words',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'Adjustment4$WordsAndNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P1Passport#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P1PermanentResidence#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P1BirthCertificate#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P1IndianStatus#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P1WorkPermit#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P1WorkPermitExpiry',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P2Passport#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P2PermanentResidence#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P2BirthCertificate#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P2IndianStatus#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P2WorkPermit#',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'P2WorkPermitExpiry',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadInstitution',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadBranch',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadAccount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadBranchAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadAccountHolderFullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Miscellaneous 3',
    name: 'PadAccountHolderAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'PadAccountHolderPhone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'PadAccountHolderCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'PadAccountHolderProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'PadAccountHolderPostalCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceFeeByMonths',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceFeeByMonthsWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceTermByMonths',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceTermByMonthsWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceFeeByAdjustment',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceFeeByAdjustmentWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'MaintenanceFeeTotal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'toMaintenanceFeeTotal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'firstOccupancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Occupancy',
    name: 'firstOccupancyDay',
    fontSize: 9,
    index: 0,
    format: 'do',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'firstOccupancyMonth',
    fontSize: 9,
    index: 0,
    format: 'MMMM',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'firstOccupancyYear',
    fontSize: 9,
    index: 0,
    format: 'yyyy',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'finalOccupancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Occupancy',
    name: 'finalOccupancyDay',
    fontSize: 9,
    index: 0,
    format: 'do',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'finalOccupancyMonth',
    fontSize: 9,
    index: 0,
    format: 'MMMM',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'finalOccupancyYear',
    fontSize: 9,
    index: 0,
    format: 'yyyy',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'firmOccupancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Occupancy',
    name: 'firmOccupancyDay',
    fontSize: 9,
    index: 0,
    format: 'do',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'firmOccupancyMonth',
    fontSize: 9,
    index: 0,
    format: 'MMMM',
    type: 'merge',
  },
  {
    category: 'Occupancy',
    name: 'firmOccupancyYear',
    fontSize: 9,
    index: 0,
    format: 'yyyy',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'outsideOccupancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Purchaser Information',
    name: 'outsideOccupancyDay',
    fontSize: 9,
    index: 0,
    format: 'do',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'outsideOccupancyMonth',
    fontSize: 9,
    index: 0,
    format: 'MMMM',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'outsideOccupancyYear',
    fontSize: 9,
    index: 0,
    format: 'yyyy',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'noticePeriod',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Purchaser Information',
    name: 'noticePeriodDay',
    fontSize: 9,
    index: 0,
    format: 'do',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'noticePeriodMonth',
    fontSize: 9,
    index: 0,
    format: 'MMMM',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'noticePeriodYear',
    fontSize: 9,
    index: 0,
    format: 'yyyy',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'terminationPeriod',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Purchaser Information',
    name: 'terminationPeriodDay',
    fontSize: 9,
    index: 0,
    format: 'do',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'terminationPeriodMonth',
    fontSize: 9,
    index: 0,
    format: 'MMMM',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'terminationPeriodYear',
    fontSize: 9,
    index: 0,
    format: 'yyyy',
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'toP1FName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'toP1LName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'toP1FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Purchaser Information',
    name: 'toP1Sin',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP1Dob',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP1Address',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP1Phone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP1Email',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2FName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2LName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2Sin',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2Dob',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2Address',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2Phone',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'toP2Email',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'oldPurchaserInformation1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'newPurchaserInformation1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'oldPurchaserInformation2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'newPurchaserInformation2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'oldPurchaserInformation3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'newPurchaserInformation3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'oldPurchaserInformation4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'newPurchaserInformation4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'oldPurchaserInformation5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'newPurchaserInformation5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  // Add/Delete Purchaser
  {
    category: 'Add Purchaser',
    name: 'AddAllFullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PFN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PLN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PLNCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PfullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PfullNameLCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PDob',
    fontSize: 9,
    index: 1,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PSIN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PPhone',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PFullAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PCity',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PProvince',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PPCode',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PCountry',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PEmail',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PIDNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PSO',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add1PBusinessNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add2PFN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add2PLN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add2PLNCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add2PfullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add2PfullNameLCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Add Purchaser',
    name: 'Add2PDob',
    fontSize: 9,
    index: 1,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PSIN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PPhone',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PFullAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PCity',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PProvince',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PPCode',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PCountry',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PEmail',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PIDNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PSO',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Add2PBusinessNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PFN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PLN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PLNCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PfullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PfullNameLCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PDob',
    fontSize: 9,
    index: 1,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PSIN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PPhone',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PFullAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PCity',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PProvince',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PPCode',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PCountry',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PEmail',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PIDNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete1PSO',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete2PFN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete2PLN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete2PLNCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete2PfullName',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Delete Purchaser',
    name: 'Delete2PfullNameLCaps',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PDob',
    fontSize: 9,
    index: 1,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PSIN',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PPhone',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PFullAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PAddress',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PCity',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PProvince',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PPCode',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PCountry',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PEmail',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PIDNumber',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'Delete2PSO',
    fontSize: 9,
    index: 1,
    type: 'merge',
  },
  // Deposit/Unit Transfers
  {
    category: 'Deposit/Unit Transfers',
    name: 'toSuite',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toUnit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toLevel',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toTier',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toRental',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toPriceW',
    fontSize: 6,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toTotalP',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toTotalPW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toNetUPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toNetTotalP',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP1Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP1Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP2Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP2Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP3Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP3Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP4Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP4Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP5Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP5Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP6Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP6Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP7',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP7Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP7Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP8',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers',
    name: 'toOP8Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP8Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP9',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP9Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP9Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP10',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP10Price',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toOP10Num',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit1W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit1Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit1DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit1%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit2W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit2Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit2DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit2%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit3W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit3Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit3DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit3%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit4W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit4Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit4DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit4%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit5',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit5W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit5Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit5DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit5%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit6',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit6W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit6Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit6DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit6%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit7',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit7W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit7Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit7DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit7%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit8',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit8W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit8Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit8DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit8%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit9',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit9W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 2',
    name: 'toDeposit9Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit9DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit9%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit10',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit10W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit10Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit10DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit10%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit11',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit11W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit11Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit11DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit11%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit12',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit12W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit12Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit12DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit12%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit13',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit13W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit13Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit13DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit13%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit14',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit14W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit14Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit14DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit14%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit15',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit15W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit15Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit15DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit15%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit16',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit16W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit16Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit16DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit16%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit17',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit17W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit17Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit17DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit17%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit18',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit18W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit18Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit18DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit18%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit19',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit19W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 3',
    name: 'toDeposit19Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit19DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit19%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit20',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit20W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit20Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit20DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit20%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit21',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit21W',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit21Date',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit21DateWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'PPP',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toDeposit21%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to4thLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to4thLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to4thLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to4thLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to3rdLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to3rdLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to3rdLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to3rdLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to2ndLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to2ndLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to2ndLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'to2ndLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toLastDepositW',
    fontSize: 6,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toLastDeposit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Deposit/Unit Transfers 4',
    name: 'toLastDepositDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Decor',
    name: 'toLastDeposit%',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'toTotalParkingPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'toTotalParkingNum',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'toTotalParkingAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'toTotalLockerPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'toTotalLockerNum',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'toTotalLockerAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG1TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'UPG1TPriceNetHST',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'UPG1Credit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG2TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'UPG2TPriceNetHST',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'UPG2Credit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG3TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'UPG3TPriceNetHST',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'UPG3Credit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG1UPG2Total',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG1UPG2TotalNet',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG1UPG2UPG3Total',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'UPG1UPG2UPG3TotalNet',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Decor',
    name: 'DecorSelection1TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'DecorSelection1ToTPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'DecorSelection2TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'DecorSelection2ToTPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'DecorSelection3TPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'DecorSelection3ToTPrice',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: '0',
  },
  {
    category: 'Decor',
    name: 'DecorSelectionTotalNetHST',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'DecorSelectionTotal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'DecorSelectionTotal',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'LeaseOP1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'LeaseOP2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'LeaseOP3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'LeaseOP4',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'ManagementFee',
    fontSize: 7,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'ReRentalFee',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'Inspection',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'LeaseRenewal',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'StartUpFee',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'ResidentP1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Assignment',
    name: 'ResidentP2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'PropertyInsurance',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'AllAssignorFullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor1FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor1FirstName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor1LastName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor2FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor2FirstName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor2LastName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor3FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor3FirstName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor3LastName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor4FullName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor4FirstName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Rental Management',
    name: 'Assignor4LastName',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ScheduleTo',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ScheduleAndTo',
    fontSize: 8,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'AllLfullNameListing',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingProjectAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingFullAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingAddressNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingPostalCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Listing',
    name: 'ListingStartDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Listing',
    name: 'ListingStartDateDay',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'do',
  },
  {
    category: 'Listing',
    name: 'ListingStartDateMonth',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'MMMM',
  },
  {
    category: 'Listing',
    name: 'ListingStartDateYear',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yy',
  },
  {
    category: 'Listing',
    name: 'ListingEndDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'Listing',
    name: 'ListingEndDateDay',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'do',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingEndDateMonth',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'MMMM',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingEndDateYear',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yy',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingAmountWords',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingCommission',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'CooperatingCommission',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Holdover',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Holdover',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingPendingAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingPendingExpiryDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'P',
  },
  {
    category: 'MLS Data Form',
    name: 'ListingReason',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'MlsNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSListingStartDateDay',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'dd',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSListingStartDateMonth',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'MM',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSListingStartDateYear',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSListingEndDateDay',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'dd',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSListingEndDateMonth',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'MM',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSListingEndDateYear',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSPossessionDateDay',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'dd',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSPossessionDateMonth',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'MM',
  },
  {
    category: 'MLS Data Form',
    name: 'MLSPossessionDateYear',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy',
  },
  {
    category: 'MLS Data Form',
    name: 'PossessionRemarks',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'GarageParking',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'DriveParking',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'TotalParking',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'SqftSource',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'TotalRooms',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'TotalRoomsAdditional',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'NumberOfBedrooms',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'NumberOfBedroomsAdditional',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'NumberOfKitchens',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'NumberOfKitchensAdditional',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Washroom1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Pieces1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Washroom2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Pieces2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Washroom3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Pieces3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room1Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room2Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room2Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form',
    name: 'Room2Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room2Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room2Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room2Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room2Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room2Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room3Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room4Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room5Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room6Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room7Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room8Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room8Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'MLS Data Form 2',
    name: 'Room8Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room8Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room8Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room8Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room8Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room8Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room9Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Name',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Length',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Width',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Height',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Description1',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Description2',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'Room10Description3',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L1FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L1LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L1FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L1EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L1PhoneTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L2FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L2LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L2FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L2EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L2PhoneTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L3FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L3LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L3FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L3EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 1',
    name: 'L3PhoneTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'L4FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'L4LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'L4FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'L4EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'L4PhoneTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T1FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T1LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T1FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T1EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T2FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T2LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T2FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T2EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T3FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T3LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T3FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T3EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T4FirstNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T4LastNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T4FullNameTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'T4EmailTenancy',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'ParkingDescription',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LandlordUnitNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LandlordStreetNumber',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LandlordStreetAddress',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LandlordCity',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LandlordProvince',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LandlordPCode',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'TenancyTypeFixedCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'TenancyTypeMonthlyCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'TenancyTypeOtherCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'TenancyStartDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy/MM/dd',
  },
  {
    category: 'Tenancy 2',
    name: 'TenancyEndDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy/MM/dd',
  },
  {
    category: 'Tenancy 2',
    name: 'PaymentDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'PaymentTypeMonthlyCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'PaymentTypeOtherCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'LeaseAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'PayableTo',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'PaymentMethod',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'PartialRentAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 2',
    name: 'PartialRentPaymentDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy/MM/dd',
  },
  {
    category: 'Tenancy 2',
    name: 'PartialRentStartDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy/MM/dd',
  },
  {
    category: 'Tenancy 2',
    name: 'PartialRentEndDate',
    fontSize: 9,
    index: 0,
    type: 'merge',
    format: 'yyyy/MM/dd',
  },
  {
    category: 'Tenancy 2',
    name: 'GasCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'GasNoCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'ACCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'ACNoCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'StorageCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'StorageNoCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'LaundryCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'LaundryNoCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'LaundryNoCharge',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'LaundryPayPerUse',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'GuestParkingCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'GuestParkingNoCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'GuestParkingNoCharge',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'GuestParkingPayPerUse',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'LockerDescription',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'ElectricityLandlordCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'ElectricityTenantCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'HeatLandlordCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'HeatTenantCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 3',
    name: 'WaterLandlordCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'WaterTenantCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'NoRentDiscountCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'RentDiscountCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'RentDiscountDescription',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'RentDiscountDescription',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'NoRentDepositCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'RentDepositCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'RentDepositAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'NoKeyDepositCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'KeyDepositCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'KeyDepositAmount',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'KeyDepositDescription',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'NoSmokingRulesCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'SmokingRulesCheck',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    category: 'Tenancy 4',
    name: 'SmokingRulesDescription',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
];

export const floorplanMerges = [
  {
    name: 'Suite',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    name: 'Unit',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
  {
    name: 'Level',
    fontSize: 9,
    index: 0,
    type: 'merge',
  },
];

export const idTypes = [
  "Driver's Licence",
  'Passport',
  'Permanent Resident Card',
  'Photo Card',
  'Citizenship Card',
  'Identity Card',
  'Articles of Incorporation',
  'Birth Certificate',
  'Indian Status',
];

export const proofTypes = ['Birth Certificate', 'Indian Status', 'Work Permit', 'Passport', 'Permanent Resident Card', 'Citizenship Card'];

export const idIssuedBy = [
  'Ontario',
  'Canada',
  'Quebec',
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Prince Edward Island',
  'Saskatchewan',
  'Yukon',
  'International Government',
];

export const createDealSteps = ['Purchaser Info', 'Realtor Info', 'Suite Info', 'APS', 'Review'];

export const noRealtorOptions = ['Friends and Family', 'Public'];

export const endvestor = ['Investor', 'End User', 'Both'];

export const amountType = [
  'Percentage',
  'Fixed',
  'Balance to 1.5%',
  'Balance to 2.5%',
  'Balance to 3%',
  'Balance to 5%',
  'Balance to 7.5%',
  'Balance to 10%',
  'Balance to 15%',
  'Balance to 10% Monthly',
  'Balance to 10% Monthly to Next Date',
  'Balance to 15% Monthly',
  'Balance to 15% Monthly to Next Date',
  'Balance to 15% Monthly (36 Months)',
];

export const dateType = [
  'Number of Days Due',
  'Specific Date',
  'Purchaser Signing Date',
  '1st of Every Month after 1st Deposit',
  '1st of Every Month after 2nd Deposit',
  '1st of Every Month after 3rd Deposit',
  'Every Month after 1st Deposit',
  'Every Month after 2nd Deposit',
  'Every Month after 3rd Deposit',
  'Floating Date',
  '90 Days Before Firm Occupancy',
  '120 Days Before Firm Occupancy',
  '180 Days Before Firm Occupancy',
  'Firm Occupancy',
  'Final Tentative Occupancy',
];

export const mergeType = [
  'APS',
  'UnitTransfer',
  'Deposit',
  'Options',
  'PurchaserInformation',
  'AddPurchasers',
  'DeletePurchasers',
  'AddDeletePurchasers',
  'Coop',
  'Decor',
  'Other',
  'Fintrac',
  'Mandatary',
  'Assignment',
  'Tenancy',
  'Listing',
  'Management',
  'Leasing',
  'Floorplan',
  'Archive',
];

export const lenders = ['CIBC', 'BMO', 'TD', 'National Bank', 'RBC', 'ScotiaBank'];

export const tags = [
  'Friends and Family',
  'Public',
  'Special Pricing',
  'Free Parking',
  'Free Locker',
  'Special Incentive',
  'Credit Incentive',
  'EV Ready',
];

export const placeholders = [
  '{{Suite}}',
  '{{Unit}}',
  '{{Level}}',
  '{{1P First Name}}',
  '{{1P Last Name}}',
  '{{Address}}',
  '{{City}}',
  '{{Province}}',
  '{{Postal Code}}',
  '{{Country}}',
  '{{Email}}',
  '{{Date of Birth}}',
  '{{Day}}',
  '{{Month}}',
  '{{Year}}',
  '{{Phone Number}}',
  '{{2P First Name}}',
  '{{2P Last Name}}',
  '{{2P Date Of Birth}}',
  '{{2P SIN}}',
  '{{3P First Name}}',
  '{{3P Last Name}}',
  '{{3P Date Of Birth}}',
  '{{3P SIN}}',
  '{{Deposit 1 Numbers}}',
  '{{Deposit 1 Words}}',
  '{{Deposit 2 Numbers}}',
  '{{Deposit 2 Words}}',
  '{{Deposit 3 Numbers}}',
  '{{Deposit 3 Words}}',
  '{{Deposit 4 Numbers}}',
  '{{Deposit 4 Words}}',
  '{{Deposit 5 Numbers}}',
  '{{Deposit 5 Words}}',
  '{{Deposit 6 Numbers}}',
  '{{Deposit 6 Words}}',
  '{{Deposit 7 Numbers}}',
  '{{Deposit 7 Words}}',
  '{{Unit Price}}',
  '{{Total Price}}',
];

export const rangeInfo = [
  {
    min: 0,
    max: 599999,
  },
  {
    min: 600000,
    max: 799999,
  },
  {
    min: 800000,
    max: 999999,
  },
  {
    min: 1000000,
    max: 1199999,
  },
  {
    min: 1200000,
    max: 1399999,
  },
  {
    min: 1400000,
    max: 1599999,
  },
  {
    min: 1600000,
    max: 1799999,
  },
  {
    min: 1800000,
    max: 1999999,
  },
  {
    min: 2000000,
    max: 2199999,
  },
  {
    min: 2200000,
    max: 2399999,
  },
  {
    min: 2400000,
    max: 2599999,
  },
  {
    min: 2600000,
    max: 2799999,
  },
  {
    min: 2800000,
    max: 2999999,
  },
  {
    min: 3000000,
    max: 3199999,
  },
  {
    min: 3200000,
    max: 3399999,
  },
  {
    min: 3400000,
    max: 3599999,
  },
  {
    min: 3600000,
    max: 999999999,
  },
];

export const chequeTypes = [
  {
    value: 'Not Received',
    color: '#dfdfdf',
  },
  {
    value: 'Received',
    color: '#92ff92',
  },
  {
    value: 'Distributed',
    color: '#b4b4f3',
  },
  {
    value: 'Replacement',
    color: '#ffff99',
  },
  {
    value: 'Nsf',
    color: '#ff8888',
  },
  {
    value: 'Cleared',
    color: '#FF8C00',
  },
  {
    value: 'Wire',
    color: '#5eb0f7',
  },
  {
    value: 'Floating',
    color: '#ff99e9',
  },
  {
    value: 'Pad',
    color: '#8cffef',
  },
  {
    value: 'Forfeited',
    color: '#35b19a80',
  },
];

export const dates = ['P', 'PP', 'PPP', 'PPPP', 'M', 'MM', 'MMM', 'MMMM', 'yy', 'yyyy', 'D', 'Do', 'DD'];

export const taskLabels = [
  'Urgent',
  'Bug',
  'Quality of Life Improvement',
  'New Feature',
  'Add Purchaser',
  'Delete Purchaser',
  'Add Option',
  'Delete Option',
  'Cheques',
  'Deposit Structure',
  'Worksheet',
  'Amendment',
  'Unit Transfer',
  'Purchaser Information',
  'Audit',
  'E-Blast',
  'Package',
  'Listing',
  'Rental Management',
  'Tenancy',
  'Event Prep',
  'Plan Changes',
  'Matrix Update',
  'Other',
];

export const outstandingChequeTypes: { [name: string]: string } = {
  received: '#92ff92',
  distributed: '#b4b4f3',
  replacement: '#ffff99',
  nsf: '#f9a460',
  notReceived: '#ff8888',
  cleared: '#FF8C00',
  wire: '#5eb0f7',
  floating: '#ff99e9',
  pad: '#8cffef',
  forfeited: '#35b19a80',
};

export const chequeDescriptions: { [name: string]: string } = {
  received: 'We have received the cheque',
  distributed: 'The cheque has been distributed to the lawyers',
  replacement: 'The cheque needs to be replaced',
  nsf: 'The cheque has gone NSF',
  notReceived: 'Not Received',
  cleared: 'Cheque has been successfully deposited',
  wire: 'Provided/Providing wire transfer',
  floating: 'There is no specified due date for deposit',
  pad: 'Pre-Authorized Debit',
};

export const questionTypes = ['dropdown', 'checkbox', 'radio', 'text', 'conditionalDropdown'];

export const daysOfTheWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const displayTypes = ['public', 'authenticated', 'both'];

export const accessTypes = ['platinum', 'vip', 'regular'];

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

export const commentTypes = ['General', 'Mortgage', 'Deposit', 'Amendment', 'Decor'];

export const holidays = ['05/23/2022', '07/01/2022', '08/01/2022', '09/05/2022', '10/10/2022', '12/25/2022', '12/31/2022'];

export const dashboardTableTitle = ['Sales Summary', 'Inventory Summary', 'Total Unit Summary', 'Total Summary'];

export const mainCategories = [
  'Suite',
  'Kitchen',
  'Dining',
  'Living',
  'Primary Bedroom',
  '2nd Bedroom',
  '3rd Bedroom',
  'Den',
  'Primary Ensuite Bathroom',
  'Ensuite Bathroom',
  '2nd Ensuite Bathroom',
  'Main Bathroom',
  'Bathroom',
  '2nd Bathroom',
  'Powder Room',
  'Terrace',
  'Flooring',
  'Stairs',
  'Foyer',
  'Hallway',
  'Appliances',
  'Blinds',
  'Closets',
  'Baseboard Trim',
  'Extra',
  'Parking',
  'Miscellaneous',
  'Accessibility',
];

export const subCategories = [
  'Miscellaneous',
  'Kitchen',
  'Bathroom',
  'Ensuite Bathroom',
  'Primary Ensuite Bathroom',
  '2nd Ensuite Bathroom',
  'Primary Bedroom',
  'Powder Room',
  '2nd Bedroom',
  '3rd Bedroom',
  'Dining',
  'Foyer',
  'Hallway',
  'Living',
  'Den',
  'Flooring',
  'Terrace',
  'Lighting',
  'Receptacle',
  'Switch',
  'Electrical',
  'Wall',
  'Upper Cabinets',
  'Closets',
  'Appliance',
  'Credit',
  'Coordination',
  'Door Handles',
  'Paint',
  'Countertop & Backsplash',
  'Pulls',
  'Faucet',
  'Lower Cabinets',
  'Upper Cabinets',
  'Floor Tile',
  'Wall Tile',
  'Vanity Countertop',
  'Vanity Faucet',
  'Vanity & Medicine Cabinet',
  'Shower Sill',
  'Shower Faucet Set',
];

export const upgradeTypes = ['STD', 'UPG1', 'UPG2', 'UPG3', 'UPG4', 'UPG5', 'ALaCarte'];

export const schemes = ['Light Standard', 'Light Upgrade', 'Dark Standard', 'Dark Upgrade'];

export const revisions = ['Project', 'Suite', 'Address', 'Not Signed', 'No Letterhead', 'Amount', 'Other', 'No MPA Required'];

export const coopTypes = ['Days After Firm', 'Milestone/Fixed', 'Closing', 'Assignment'];

export const checklist = [
  {
    name: 'Review and action all emails and voicemails throughout the day.',
    completed: null,
    user: null,
  },
  {
    name: 'Firm deals when applicable.',
    completed: null,
    user: null,
  },
  {
    name: 'Prepare and schedule any distribution.',
    completed: null,
    user: null,
  },
  {
    name: 'Follow-up for any outstanding items to ensure files are broker complete.',
    completed: null,
    user: null,
  },
  {
    name: 'Prepare and send daily report.',
    completed: null,
    user: null,
  },
];

export const tenancyLength = ['Fixed Length of Time', 'Monthly', 'Other'];

export const daysOfMonth = [
  'First',
  'Second',
  'Third',
  'Fourth',
  'Fifth',
  'Sixth',
  'Seventh',
  'Eighth',
  'Nineth',
  'Tenth',
  'Eleventh',
  'Twelfth',
  'Thirteenth',
  'Fourteenth',
  'Fifteenth',
  'Sixteenth',
  'Seventeenth',
  'Eighteenth',
  'Nineteenth',
  'Twentieth',
  'Twenty-first',
  'Twenty-second',
  'Twenty-third',
  'Twenty-fourth',
  'Twenty-fifth',
  'Twenty-sixth',
  'Twenty-seventh',
  'Twenty-eighth',
  'Twenty-nineth',
  'Thirtieth',
  'Thirty-first',
];
export const unitTypesColour = (unit: IUnit) => {
  if (unit.unitType === '3BR' || unit.unitType === '3BR(I)' || unit.unitType === '3BR+M' || unit.unitType === '3BR+F') {
    return '#ff8100';
  } else if (unit.unitType === '2BR+D' || unit.unitType === '2BR+D(I)' || unit.unitType === '2BR+M(I)') {
    return '#ffc181';
  } else if (
    unit.unitType === '2BR' ||
    unit.unitType === '2BR(I)' ||
    unit.unitType === '2BR+M' ||
    unit.unitType === '2BR+F' ||
    unit.unitType === '2BR+S' ||
    unit.unitType === 'JR2'
  ) {
    return '#e7b589';
  } else if (unit.unitType === '1BR+D' || unit.unitType === '1BR+D(I)' || unit.unitType === '1BR+M(I)') {
    return '#91f18f';
  } else if (
    unit.unitType === '1BR' ||
    unit.unitType === '1BR(I)' ||
    unit.unitType === '1BR+M' ||
    unit.unitType === '1BR+F' ||
    unit.unitType === '1BR+S'
  ) {
    return '#c9ffc8';
  } else if (unit.unitType === 'Studio' || unit.unitType === 'JR1BR') {
    return '#c4f1fb';
  } else if (unit.unitType === '4BR') {
    return '#35f7c2';
  } else if (unit.unitType === 'TH') {
    return '#35eef7';
  }
};

export const exposures = [
  'North',
  'NorthEast',
  'NorthWest',
  'North (C)',
  'South',
  'SouthEast',
  'SouthWest',
  'South (C)',
  'East',
  'East (C)',
  'West',
  'West (C)',
  'NorthEastWest',
  'NorthSouthWest',
  'NorthSouthEast',
  'SouthEastWest',
];

export const outdoorTypes = ['Juliet', 'Patio', 'Balcony', 'Balcony + Terrace', 'Terrace', 'Courtyard', 'Open', 'Enclosed', 'None'];

export const randomColors = [
  '#B22222',
  '#008000',
  '#5757e5',
  '#ffa500',
  '#b697cd',
  '#F08080',
  '#9ACD32',
  '#00FFFF',
  '#FFA07A',
  '#9370DB',
  '#A0522D',
  '#DAA520',
  '#DC143C',
  '#7FFF00',
  '#AFEEEE',
  '#FF6347',
  '#DEB887',
  '#BDB76B',
];

export const baseStyle = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: 'rgb(199 199 199)',
  borderStyle: 'dashed',
  backgroundColor: 'rgb(241 241 241)',
  color: '#2e453d',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  margin: '20px 0',
  cursor: 'pointer',
};

export const activeStyle = {
  borderColor: '#2196f3',
};

export const acceptStyle = {
  borderColor: '#00e676',
};

export const rejectStyle = {
  borderColor: '#ff1744',
};

export const unitColumns = [
  {
    label: 'Status',
    id: 'status',
  },
  {
    label: 'Number of Suites',
    id: 'count',
  },
  {
    label: 'Size',
    id: 'size',
  },
  {
    label: 'Revenue',
    id: 'revenue',
  },
  {
    label: 'PPSF',
    id: 'ppsf',
  },
  {
    label: 'Revenue Net',
    id: 'revenueNet',
  },
  {
    label: 'PPSF Net',
    id: 'ppsfNet',
  },
];

export const optionColumns = [
  {
    label: 'Option',
    id: 'option',
  },
  {
    label: 'Current Price',
    id: 'currentPrice',
  },
  {
    label: 'Total Options',
    id: 'totalOptions',
  },
  {
    label: 'Available',
    id: 'available',
  },
  {
    label: 'Available Revenue',
    id: 'availableRevenue',
  },
  {
    label: 'Available Revenue Net Hst',
    id: 'availableRevenueNetHst',
  },
  {
    label: 'Pending Options',
    id: 'pendingOptions',
  },
  {
    label: 'Sold Options',
    id: 'soldOptions',
  },
  {
    label: 'Combined Options',
    id: 'combinedOptions',
  },
  {
    label: 'Pending Revenue',
    id: 'pendingRevenue',
  },
  {
    label: 'Sold Revenue',
    id: 'soldRevenue',
  },
  {
    label: 'Combined Revenue',
    id: 'combinedRevenue',
  },
  {
    label: 'Total PPSF',
    id: 'totalPPSF',
  },
  {
    label: 'Total Revenue',
    id: 'totalRevenue',
  },
];

export const totalColumns = [
  {
    label: 'Type',
    id: 'type',
  },
  {
    label: 'Sold Unit Revenue',
    id: 'soldUnitRevenue',
  },
  {
    label: 'Sold Unit Revenue Net HST',
    id: 'soldUnitRevenueNetHst',
  },
  {
    label: 'Sold Options Revenue',
    id: 'soldOptionsRevenue',
  },
  {
    label: 'Overall Sold Revenue',
    id: 'overallSoldRevenue',
  },
  {
    label: 'Overall Sold Revenue Net HST',
    id: 'overallSoldRevenueNetHst',
  },
];

export const adjustmentColumns = [
  {
    label: 'Adjustment',
    id: 'name',
  },
  {
    label: 'Count',
    id: 'count',
  },
  {
    label: 'Amount',
    id: 'amount',
  },
];

export const adjustmentWidths = {
  name: 15,
  count: 15,
  amount: 15,
};

export const pdfAdjustmentWidths = {
  name: 200,
  count: 200,
  amount: 200,
};

export const unitWidths = {
  status: 15,
  count: 15,
  size: 15,
  revenue: 15,
  revenueNet: 15,
  ppsf: 15,
  ppsfNet: 15,
};

export const pdfUnitWidths = {
  status: 200,
  count: 200,
  size: 200,
  revenue: 200,
  revenueNet: 200,
  ppsf: 200,
  ppsfNet: 200,
};

export const optionWidths: any = {
  option: 15,
  currentPrice: 15,
  totalOptions: 15,
  available: 15,
  availableRevenue: 15,
  availableRevenueNetHst: 15,
  pendingOptions: 15,
  soldOptions: 15,
  combinedOptions: 15,
  pendingRevenue: 15,
  soldRevenue: 15,
  combinedRevenue: 15,
  totalPPSF: 15,
  totalRevenue: 30,
  totalRevenueNetHst: 30,
};

export const pdfOptionWidths: any = {
  option: 200,
  currentPrice: 200,
  totalOptions: 200,
  available: 200,
  availableRevenue: 200,
  availableRevenueNetHst: 200,
  pendingOptions: 200,
  soldOptions: 200,
  combinedOptions: 200,
  pendingRevenue: 200,
  soldRevenue: 200,
  combinedRevenue: 200,
  totalPPSF: 200,
  totalRevenue: 200,
  totalRevenueNetHst: 200,
};

export const totalWidths = {
  type: 15,
  soldUnitRevenue: 30,
  soldOptionsRevenue: 30,
  soldUnitRevenueNetHst: 30,
  overallSoldRevenue: 30,
  overallSoldRevenueNetHst: 30,
};

export const pdfTotalWidths = {
  type: 200,
  soldUnitRevenue: 200,
  soldOptionsRevenue: 200,
  soldUnitRevenueNetHst: 200,
  overallSoldRevenue: 200,
  overallSoldRevenueNetHst: 200,
};

export const conditionFields = ['netHstBasePrice', 'unitTypes', 'modelTypes', 'size', 'maintenance', 'rental'];

export const numberConditions = ['Less Than', 'Greater Than'];

export const wordConditions = ['Includes'];

export const packageHeaders = [
  'Model',
  'Suite Type',
  'Floor',
  'View',
  'Bathroom',
  'Interior Size',
  'Exterior Size',
  'Total Size',
  'Starting Price',
  'Starting Price*',
  'Lease Amount',
];

export const sortOrders = ['basePrice', 'modelType', 'size', 'outdoorSize', 'level', 'unitType', 'exposure', 'totalSize'];

export const realtorSummaryUnitTypes = [
  'studio',
  'jrOneBr',
  'oneBr',
  'oneBrInbound',
  'oneBrMedia',
  'oneBrFlex',
  'oneBrDen',
  'oneBrDenInbound',
  'twoBr',
  'twoBrInbound',
  'twoBrMedia',
  'twoBrFlex',
  'twoBrDen',
  'twoBrDenInbound',
  'juniorTwo',
  'threeBr',
  'threeBrInbound',
  'threeBrMedia',
  'threeBrFlex',
  'threeBrDen',
  'th',
];

export const docusignStatus = [
  'Not Completed',
  'Sent',
  'Signed',
  'Completed',
  'Revoked',
  'Expired'
];

export const tokens = [
  {
    category: "General Tokens",
    items: [
      {
        name: "All Purchasers Full Name",
        value: "pFullName",
      },
      {
        name: "P1 First Name",
        value: "p1FirstName",
      },
      {
        name: "P1 Last Name",
        value: "p1LastName",
      },
      {
        name: "P1 Phone Number",
        value: "p1PrimaryPhone",
      },
      {
        name: "P1 Address",
        value: "p1Address",
      },
       {
        name: "P2 First Name",
        value: "p2FirstName",
      },
      {
        name: "P2 Last Name",
        value: "p2LastName",
      },
      {
        name: "P2 Phone Number",
        value: "p2PrimaryPhone",
      },
      {
        name: "P2 Address",
        value: "p2Address",
      },
      {
        name: "Project Name",
        value: "projectName",
      },
      {
        name: "Developer Name",
        value: "developerName",
      },
      {
        name: "Suite",
        value: "suite",
      },
      {
        name: "Today's Date",
        value: "today",
      },
      {
        name: "Cooling Off Date",
        value: "coolingOffDate",
      }
    ],
  },
];

export const libertyProjects = ['69f0c0d674ae8abf5aa5418c', '699cb6141986761ed88de57a', '69f0d9058e29654d6346581d', '6a95ea574cb0f62c0b581594']
